import Ajax from '../../../../common/js/Ajax.js';
import MessageUtils from '../../../../common/js/MessageUtils.js';
import Widget from '../../../../common/js/Widget.js';

export default class LogoutWidget extends Widget {

	constructor($widget) {
		super($widget);
		Ajax.rpc('/logout', () => {
			MessageUtils.ok($widget, 'You have been logged out successfully.\n[Login again|/admin]');
		}, error => {
			MessageUtils.error($widget, 'Failed to logout', error);
		});
	}

}
